import React, { useState, Fragment } from "react";
import { useQueryClient } from 'react-query';
import { makeStyles } from "@material-ui/core/styles";
import {Grid, Icon, Tooltip} from "@material-ui/core";

import FuelTooltipStyles from "../styles/FuelTooltipStyles";
import {CurrencyValue} from "../../../controls";


const FuelValues = (props) => {
  const {movement} = props;

//  if (tripLeg.aircraftMovementUuid===null) return null;
  const classes = makeStyles(FuelTooltipStyles)();

  let previousFuel = "";
  let uplifted = "";
  let upliftFuelQuantity = "";
  let upliftFuelDensity = "";
  let upliftFuelSlipNumber = "";
  let offBlocksFuel = "";
  let takeOffFuel = "";
  let LandingFuel = "";
  let blocksOnFuel = "";
  const padding = 5;

  if (movement) {
    if (movement.previousFuelOnBoardKg) {
      previousFuel = `${movement.previousFuelOnBoardKg.toLocaleString()} Kg`;
    }
    if (movement.upliftFuelKg) {
      uplifted = `${movement.upliftFuelKg.toLocaleString()} Kg`;
    }
    if (movement.upliftFuelQuantity) {
      upliftFuelQuantity = `${movement.upliftFuelQuantity.toLocaleString()} ${movement.upliftFuelUom ?? ""}`;
    }
    if (movement.upliftFuelDensity) {
      upliftFuelDensity = `${movement.upliftFuelDensity.toLocaleString()}`;
    }
    if (movement.upliftFuelSlipNumber) {
      upliftFuelSlipNumber = `${movement.upliftFuelSlipNumber}`;
    }
    if (movement.offBlocksFuelKg) {
      offBlocksFuel = `${movement.offBlocksFuelKg.toLocaleString()} Kg`;
    }
    if (movement.takeOffFuelKg) {
      takeOffFuel = `${movement.takeOffFuelKg.toLocaleString()} Kg`;
    }
    if (movement.landingFuelKg) {
      LandingFuel = `${movement.landingFuelKg.toLocaleString()} Kg`;
    }
    if (movement.onBlocksFuelKg) {
      blocksOnFuel = `${movement.onBlocksFuelKg.toLocaleString()} Kg`;
    }
  }

  const fuelValues = (
    <Fragment>
      <Grid
        container direction="column"
        justifyContent="space-between"
      >
        <Grid container nowrap="true" key="PREVIOUS">
          <Grid item xs={6} nowrap="true" ><div style={{ display: "inline-block", paddingTop: padding, fontSize: 12 }}>{"Previous: "}</div></Grid>
          <Grid item xs={6} nowrap="true" style={{ textAlign: "right", borderBottom: "1px solid"}}>
            <div className={classes.value}>{previousFuel}</div>
          </Grid>
        </Grid>
        <Grid container nowrap="true" key="UPLIFT_QTY">
          <Grid item xs={6} nowrap="true" ><div style={{ display: "inline-block", paddingTop: padding, fontSize: 12 }}>{"Uplift Quantity: "}</div></Grid>
          <Grid item xs={6} nowrap="true" style={{ textAlign: "right", borderBottom: "1px solid"}}>
            <div className={classes.value}>{upliftFuelQuantity}</div>
          </Grid>
        </Grid>
        <Grid container nowrap="true" key="UPLIFT_DENSITY">
          <Grid item xs={6} nowrap="true" ><div style={{ display: "inline-block", paddingTop: padding, fontSize: 12 }}>{"Uplift Density: "}</div></Grid>
          <Grid item xs={6} nowrap="true" style={{ textAlign: "right", borderBottom: "1px solid"}}>
            <div className={classes.value}>{upliftFuelDensity}</div>
          </Grid>
        </Grid>
        <Grid container nowrap="true" key="UPLIFT_SLIP">
          <Grid item xs={6} nowrap="true" ><div style={{ display: "inline-block", paddingTop: padding, fontSize: 12 }}>{"Uplift Fuel Slip: "}</div></Grid>
          <Grid item xs={6} nowrap="true" style={{ textAlign: "right", borderBottom: "1px solid"}}>
            <div className={classes.value}>{upliftFuelSlipNumber}</div>
          </Grid>
        </Grid>
        <Grid container nowrap="true" key="UPLIFT">
          <Grid item xs={6} nowrap="true"><div style={{ display: "inline-block", paddingTop: padding, fontSize: 12 }}>{"Uplift: "}</div></Grid>
          <Grid item xs={6} nowrap="true" style={{  textAlign: "right", borderBottom: "1px solid" }}>
            <div className={classes.value}>{uplifted}</div>
          </Grid>
        </Grid>
        <Grid container nowrap="true" key="BLOFF">
          <Grid item xs={6} nowrap="true" ><div style={{ display: "inline-block", paddingTop: padding, fontSize: 12 }}>{"Pushback: "}</div></Grid>
          <Grid item xs={6} nowrap="true" style={{  textAlign: "right", borderBottom: "1px solid" }}>
            <div className={classes.value}>{offBlocksFuel}</div>
          </Grid>
        </Grid>
        <Grid container nowrap="true" key="TO">
          <Grid item xs={6} nowrap="true" ><div style={{ display: "inline-block", paddingTop: padding, fontSize: 12  }}>{"Takeoff: "}</div></Grid>
          <Grid item xs={6} nowrap="true" style={{ textAlign: "right", borderBottom: "1px solid" }}>
            <div className={classes.value}>{takeOffFuel}</div>
          </Grid>
        </Grid>
        <Grid container nowrap="true" key="LAND">
          <Grid item xs={6} nowrap="true" ><div style={{ display: "inline-block", paddingTop: padding, fontSize: 12 }}>{"Landing: "}</div></Grid>
          <Grid item xs={6} nowrap="true" style={{textAlign: "right", borderBottom: "1px solid" }}>
            <div className={classes.value}>{LandingFuel}</div>
          </Grid>
        </Grid>
        <Grid container nowrap="true" key="BLON">
          <Grid item xs={6} nowrap="true" ><div style={{ display: "inline-block", paddingTop: padding, fontSize: 12 }}>{"Blocks On: "}</div></Grid>
          <Grid item xs={6} nowrap="true" style={{ textAlign: "right", borderBottom: "1px solid" }}>
            <div className={classes.value}>{blocksOnFuel}</div>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  )

  return fuelValues;
}

const FuelTooltip = (props) => {
  const { movement } = props;

  const [load, setLoad] = useState("WAIT");

  const classes = makeStyles(FuelTooltipStyles)();

  let toolTipText = "Retrieving info...";

  const loadData = () => {
    if (load === "WAIT") {
      setLoad("DONE");
    }
  }

  if (load === 'DONE') {

    toolTipText = (
      <Fragment>
        <div style={{width: "100%"}}>
          {/*<div style={{textAlign: "center", fontWeight: 1000, padding: 5 }}>Flight Fuel Info</div>*/}
          <div className={classes.header}>Flight Fuel Info</div>
          <FuelValues movement={movement}/>
        </div>
      </Fragment >
    );
  }

  return (
    <Tooltip onOpen={loadData}
      classes={{ tooltip: classes.fuelTooltip }}
      placement="top-start"
      title={toolTipText}
    >
      {props.children}
    </Tooltip>
  );
}

export {
  FuelTooltip as default,
  FuelValues
};
